/** User-facing product name for the standalone movie workspace. */
export const MOVIE_STUDIO_NAME = 'Movie Studio';
